// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1i6Vx","row":"styles_row__3R91F"};